import Resource from './Resource';

// What `getInvite` answers with, and what `acceptInvite` answers with once the invite is spent.
export type InviteUser = {
	name?: string;
	userTitle?: string;
	email?: string;
};

// What `acceptInvite` is sent — disjoint from the response apart from the name and title.
export type AcceptInvite = {
	code: string | null;
	name: string;
	userTitle: string;
	password: string;
	customer: string | null;
};

// Both no-authentication userInvite routes answer with a bare user, not the {error, data} envelope.
class InviteCode extends Resource {
	constructor() {
		super('userInvite');
	}

	// Both segments come straight off the query string, so they are encoded — `$resource` did
	// that, and without it a code carrying `?` or `#` would rewrite the url rather than 404.
	get(customer: string | null, code: string): Promise<InviteUser> {
		return this._getRequest(`${encodeURIComponent(customer ?? '')}/${encodeURIComponent(code)}`, {
			methodName: 'get'
		}).then(res => res.data);
	}

	save(data: AcceptInvite): Promise<InviteUser> {
		return this._postRequest('', data, { methodName: 'save' }).then(res => res.data);
	}
}

export default new InviteCode();
